import React from 'react';
import AppNavBar from './AppNavBar';

/**
 * AuthLayout — wraps all authenticated pages with the shared nav bar.
 * Nav bar is fixed at the top (h-16 = 64px); content is offset with pt-16.
 */
const AuthLayout = ({ children }) => (
  <div className="min-h-screen bg-background">
    <AppNavBar />
    <main className="pt-16">
      {children}
    </main>
  </div>
);

export default AuthLayout;
